import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-roles-role',
  templateUrl: './roles-role.component.html',
  styleUrls: ['./roles-role.component.scss']
})
export class RolesRoleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
